/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Nav_Folder_Navigation_AriaInputs */



/**
* | output |
* | --- |
* | "Folder navigation" |
*
* @param {Explorer_Nav_Folder_Navigation_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_folder_navigation_aria = /** @type {((inputs?: Explorer_Nav_Folder_Navigation_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_Folder_Navigation_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Navigation des dossiers")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ordnernavigation")
	if (locale === "it") return /** @type {LocalizedString} */ ("Navigazione delle cartelle")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Навигация по папкам")
	if (locale === "es") return /** @type {LocalizedString} */ ("Navegación por carpetas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文件夹导航")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォルダナビゲーション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ोल्डर नेविगेशन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Navegação por pastas")
	return /** @type {LocalizedString} */ ("Folder navigation")
});